<template>
  <div>
    <line-chart
      :chart-data="chartData"
      :tooltip-coloring-rule="tooltipColoringCallback"
      :scale-x-text="scaleXText"
      :scale-y-text="scaleYText" />
  </div>
</template>

<script>
import LineChart from '@/components/Charts/LineChart.vue';

const CHART_LINE_PRESETS = {
  tension: 0.3,
  borderWidth: 3,
  fill: false,
  pointHoverBorderWidth: 3,
  pointHoverBackgroundColor: 'white',
};

const CHART_COLORS = [
  'rgba(106, 0, 53, 1)',
  'rgba(2, 157, 255, 1)',
  'rgba(255, 202, 58, 1)',
  'rgba(152, 86, 244, 1)',
  'rgba(138, 201, 38, 1)',
  'rgba(255, 0, 157, 1)',
];

export default {
  name: 'line-chart-dados-coleta',
  components: {
    'line-chart': LineChart,
  },
  props: {
    datasets: {
      type: Array,
      required: true,
    },
    tooltipColoringCallback: {
      type: Function,
      required: true,
    },
    scaleYText: {
      type: String,
      default: 'Cobertura (%)',
    },
    scaleXText: {
      type: String,
      default: 'Ano',
    },
  },
  computed: {
    chartData() {
      return {
        labels: this.getChartLabels(),
        datasets: this.getChartDatasets(),
      };
    },
  },
  methods: {
    getChartLabels() {
      const data = this.datasets[0]?.valuesByPeriod || {};
      return Object.keys(data);
    },
    getChartDatasets() {
      const formattedDatasets = this.datasets.map((datasetItem, index) => ({
        label: datasetItem.label,
        data: Object.values(datasetItem.valuesByPeriod).map(this.formatChartDataNumber),
        backgroundColor: CHART_COLORS[index],
        borderColor: CHART_COLORS[index],
        pointHoverBorderColor: CHART_COLORS[index],
        ...CHART_LINE_PRESETS,
      }));

      return formattedDatasets || [];
    },
    formatChartDataNumber(value) {
      return value.replace(',', '.');
    },
  },
};
</script>
